import main from './volume-duo.svg';
import active from './volume-filled.svg';
import disabled from './volume-gestalt.svg';

export default { main, active, disabled };
